import React, { Component } from 'react'
import { Grid, Cell } from 'react-mdl'
export default class Education extends Component {
  render() {
    return (
    <Grid>

        <Cell>
          <p>{this.props.startyear} - {this.props.endyear}</p>
        </Cell>
        <Cell>
            <h4 style={{marginTop:'0px'}}>{this.props.schoolName}</h4>
            <p>{this.props.schoolDescription}</p>
        </Cell>
    </Grid>
    )
  }
}
